export default __webpack_public_path__ + "static/media/video.5dda9282.mp4";